import { render, staticRenderFns } from "./quiz-manager.vue?vue&type=template&id=f2e728b4&scoped=true"
import script from "./quiz-manager.vue?vue&type=script&lang=ts"
export * from "./quiz-manager.vue?vue&type=script&lang=ts"
import style0 from "./quiz-manager.vue?vue&type=style&index=0&id=f2e728b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e728b4",
  null
  
)

export default component.exports